import React from "react";

const ApiUpdates = () => {
  const updates = [
    {
      title:
        "Introducing Tillionx Announcements WebSocket: Subscribe to Get Real-Time Updates and Promotions",
      date: "2025-07-28",
    },
    {
      title: "Tillionx Futures API Updates (2024-10-30)",
      date: "2024-10-22",
    },
    {
      title: "Tillionx Earn Enables API Functionality for SOL Staking",
      date: "2024-10-18",
    },
    {
      title:
        "Tillionx USDⓈ-M Futures WebSocket System Upgrade Notice (2024-10-17)",
      date: "2024-10-15",
    },
    {
      title:
        "Tillionx COIN-M Futures WebSocket System Upgrade Notice (2024-10-10)",
      date: "2024-10-09",
    },
    {
      title:
        "Tillionx COIN-M Futures WebSocket System Upgrade Notice (2024-09-26)",
      date: "2024-09-24",
    },
    {
      title: "Introducing TRADE_LITE for USDⓈ-M Futures Websocket (2024-09-03)",
      date: "2024-08-28",
    },
    {
      title: "Tillionx Futures API Service Upgrade (2024-08-21)",
      date: "2024-08-16",
    },
  ];
  return <div>
    <div className="my-16 rounded-lg shadow-sm p-6 border border-gray-200 max-w-7xl mx-auto font-sans">
      <nav className="flex items-center text-sm  mb-6">
          <span className="">Announcement</span>
          <span className="mx-2">›</span>
          <span className="font-semibold text-xs">Api Updates</span>
        </nav>
      <h2 className="text-xl font-bold mb-6">API Updates</h2>

      {/* Updates List */}
      {updates.map((item, index) => (
        <div key={index} className="py-4 border-b border-gray-200 last:border-b-0">
          <h3 className="text-base font-medium leading-snug hover:underline cursor-pointer">
            {item.title}
          </h3>
          <p className="text-sm mt-1">{item.date}</p>
        </div>
      ))}
    </div>
  </div>;
};

export default ApiUpdates;
